const listCollections = (() => {
  const collectionToggles = ".js-collectionToggle";

  function onToggleClick(e) {
    e.preventDefault();
    let toggles = document.querySelectorAll(collectionToggles)

    toggles.forEach((el) => {
      if (el == e.currentTarget) {
        el.parentNode.classList.contains('active')
        ? el.parentNode.classList.remove('active')
        : el.parentNode.classList.add('active')
      }
    })
  }

  function bind() {

    const colToggles = document.querySelectorAll(collectionToggles);
      Array.prototype.forEach.call(colToggles, (el) => {
        el.removeEventListener("click", onToggleClick);
        el.addEventListener("click", onToggleClick);
    });

  }

  function init() {
    bind();
  }

  return {
    init,
  };
})();

export default listCollections;